import { useEffect } from 'react'
import { FillRateMetrics } from './FillRateMetrics'
import { FilterBar } from '../FilterBar'
import { OverallFillRate } from './OverallFillRate'
import { Box, Flex } from '@workwhile/ui'
import { FillRateByCompany } from './FillRateByCompany'
import { ShiftNoticeMetrics } from './ShiftNoticeMetrics'
import { ShiftNoticeTimeseries } from './ShiftNoticeTimeseries'
import { FillRateByNoticeTimeseries } from './FillRateByNoticeTimeseries'
import { FillPayNoticeByLocation } from './FillPayNoticeByLocation'
import { PayRateByPosition } from './PayRateByPosition'
import { usePulseContext } from 'pages/PulsePage/context/PulseProvider'
import { EmptyState } from '../EmptyState'
import { track } from 'lib/amplitude'

export function OperationsMain() {
  const {
    state: { filters },
  } = usePulseContext()

  useEffect(() => {
    track('impression, pulse_page_operations', {
      filters,
    })
  }, [])

  return (
    <Box>
      <FilterBar />
      {filters.companyIds.length > 0 ? (
        <Flex flexDirection="column" gap={5} pb={4}>
          <FillRateMetrics />
          <OverallFillRate />
          <FillRateByCompany />
          <ShiftNoticeMetrics />
          <ShiftNoticeTimeseries />
          <FillRateByNoticeTimeseries />
          <FillPayNoticeByLocation />
          <PayRateByPosition />
        </Flex>
      ) : (
        <EmptyState />
      )}
    </Box>
  )
}
